import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SearchInput, RaceSelector, DataTable, LoadingState } from '@/components/shared';
import { DiscountsManagerViewProps } from './discountsmanager.props';
import DiscountsFormDialog from './discountsmanager.form';

const DiscountsManagerView: React.FC<DiscountsManagerViewProps> = ({
  races,
  raceTypes,
  selectedRaceId,
  setSelectedRaceId,
  searchQuery,
  setSearchQuery,
  loading,
  filteredDiscounts,
  discountColumns,
  isDialogOpen,
  setIsDialogOpen,
  editingDiscount,
  setEditingDiscount,
  formData,
  setFormData,
  handleSubmit,
  deleteTarget,
  setDeleteTarget,
  confirmDelete,
  embedded,
}) => {
  return (
    <>
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Управување со кодови за попусти</CardTitle>
              <p className="text-sm text-muted-foreground mt-1">
                Креирајте и управувајте со промотивни кодови за цел настан или за конкретен тип на трка
              </p>
            </div>
            <DiscountsFormDialog
              isDialogOpen={isDialogOpen}
              setIsDialogOpen={setIsDialogOpen}
              editingDiscount={editingDiscount}
              setEditingDiscount={setEditingDiscount}
              formData={formData}
              setFormData={setFormData}
              handleSubmit={handleSubmit}
              raceTypes={raceTypes}
              selectedRaceId={selectedRaceId}
              deleteTarget={deleteTarget}
              setDeleteTarget={setDeleteTarget}
              confirmDelete={confirmDelete}
            />
          </div>
        </CardHeader>
        <CardContent>
          {!embedded && (
            <div className="mb-4">
              <RaceSelector
                races={races}
                value={selectedRaceId}
                onChange={setSelectedRaceId}
                label="Изберете настан"
                showDate
              />
            </div>
          )}

          {!selectedRaceId && !embedded && (
            <p className="text-center text-muted-foreground py-8">Изберете настан за да ги видите кодовите за попуст.</p>
          )}

          {selectedRaceId && loading && <LoadingState />}

          {selectedRaceId && !loading && (
            <>
              <div className="mb-4">
                <SearchInput
                  value={searchQuery}
                  onChange={setSearchQuery}
                  placeholder="Пребарувај кодови..."
                />
              </div>
              <DataTable
                columns={discountColumns}
                data={filteredDiscounts}
                loading={loading}
                emptyMessage="Нема кодови за попусти за овој настан."
              />
            </>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default DiscountsManagerView;
